import i18n from 'i18next';
import { useEffect, useState } from 'react';
import useShipmentProductDimUomList from '../../../redux/hooks/useShipmentProductDimUomList';
import FormSelectBox from '../Inputs/FormSelectBox';

const ProductDimentionsUomSelector = ({
  placeholder = i18n.t('translation:default.fields.unitOfMeasurement.placeholder'),
  label = i18n.t('translation:default.fields.unitOfMeasurement.label'),
  rules = [],
  name,
  editMode,
  onChange,
  tabIndex,
  margin = 'mb-0',
}) => {
  const [options, setOptions] = useState([]);
  const dimList = useShipmentProductDimUomList();

  useEffect(() => {
    if (dimList?.length >= 0) {
      const options = dimList.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [dimList]);

  return (
    <FormSelectBox
      loading={dimList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      tabIndex={tabIndex}
      dataTestId="product-details-dimentions-uom-selector"
    />
  );
};

export default ProductDimentionsUomSelector;
